import {
  Card,
  CardContent,
  Typography,
  Box,
  alpha,
  LinearProgress,
} from "@mui/material";
import {
  ResponsiveContainer,
  Tooltip,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Cell,
  Line,
  CartesianGrid,
  ComposedChart,
} from "recharts";
import useStyles from "./styles";
import { useTheme } from "@emotion/react";

const HistogramAtendimentos = ({ data = [], title = "", loading = false }) => {
  const theme = useTheme();
  const styles = useStyles(theme);

  const chartData = (data || [])?.map((item) => ({
    hora: item.hora,
    total: Number(item.totalabertos || 0),
  }));

  const barColor = theme.palette.colors.blue.medium;

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      const item = payload[0];

      return (
        <Box sx={styles.containerTooltipDonut}>
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            {`Hora: ${item?.payload?.hora}h`}
          </Typography>

          <Typography variant="body2">
            {`${item?.value} atendimentos`}
          </Typography>
        </Box>
      );
    }
    return null;
  };

  return (
    <Card sx={{ height: "100%" }}>
      {loading && <LinearProgress />}

      <CardContent>
        <Typography variant="h8" sx={{ fontWeight: 600 }}>
          {title}
        </Typography>

        <Box sx={{ width: "100%", height: 150, mt: 1 }}>
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart
              data={chartData}
              margin={{ top: 10, right: 0, left: -30, bottom: 0 }}
            >
              <CartesianGrid
                vertical={false}
                horizontal={true}
                stroke={theme.palette.divider}
                strokeDasharray="3"
              />

              <XAxis
                dataKey="hora"
                tickFormatter={(h) => `${h}h`}
                tick={{
                  fill: theme.palette.text.primary,
                  fontSize: 10,
                }}
              />

              <YAxis
                tick={{
                  fill: theme.palette.text.primary,
                  fontSize: 10,
                }}
                allowDecimals={false}
              />

              <Tooltip
                content={<CustomTooltip />}
                cursor={{ fill: `${theme.palette.white.main}1a` }}
              />

              <Bar dataKey="total" barSize={15} radius={[2, 2, 0, 0]}>
                {chartData?.map((_, index) => (
                  <Cell key={index} fill={barColor} />
                ))}
              </Bar>
            </ComposedChart>
          </ResponsiveContainer>
        </Box>
      </CardContent>
    </Card>
  );
};

export default HistogramAtendimentos;
